import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RESPONSE_SUCESS } from '../../shared/constants/response-constants';
import Loader from "../loader/Loader";
import { IsNotNull } from "../../shared/hooks/utils";
import useApi from "../../hooks/use-api";
import { APIResponseOfListOfSearchAccountDTO, SearchAccountDTO } from "../../services/generated";
import { Card } from "../card/Card";
import { Tooltip } from "../tooltip/Tooltip";
import { Icon } from "../icon/Icon";

function AccountSearchBar(props: any) {

  const [searchText, setSearchText] = useState("");
  const [searchResultFacilities, setSearchResultFacilities] = useState<SearchAccountDTO[]>([]);
  const [showFaciltyDropdown, setShowFaciltyDropdown] = useState(false);
  const [accountNotFoundFlag, setAccountNotFoundFlag] = useState(false);
  const [loader, setLoader] = useState<boolean>(false);
  const { account: accountClient } = useApi();
  let navigate = useNavigate();

  const getRouteLink = (accountValues: any): string => {
    let url: string = (IsNotNull(accountValues?.accountNumber)) ? '/account/appointments' : '/account/patient-scheduling';
    url = url + (IsNotNull(accountValues?.accountNumber) ? '?accountNumber=' + accountValues?.accountNumber : '?');
    url = url + (IsNotNull(accountValues?.coid) ? '&coid=' + accountValues?.coid : '');
    url = url + (IsNotNull(accountValues?.mnemonic) ? '&mnemonic=' + accountValues?.mnemonic : '&mnemonic=null');
    return url;
  }

  const handleSearch = async () => {
    setLoader(true);
    if (searchText) {
      // Search Account API Call
      const response: APIResponseOfListOfSearchAccountDTO = await accountClient.searchAccount(searchText,null).catch((error: any) => {
        return error;
      });
      setShowFaciltyDropdown(false);
      setSearchResultFacilities([]);
      setAccountNotFoundFlag(false);
      setLoader(false);
      if (response.statusCode === RESPONSE_SUCESS && response.result && response.result !== null) {
        const searchResult: SearchAccountDTO[] = response.result;
        if (searchResult.length === 1) {
          // redirect to account page
          let url: string = getRouteLink(searchResult[0]);
          navigate(url);
          clearSearch();
        } else if (searchResult.length > 1) {
          // show dropdown
          setShowFaciltyDropdown(true);
          setSearchResultFacilities(searchResult);
        }
      } else if(response.result === null){
        setAccountNotFoundFlag(true);
      }
    }
    else{
      setLoader(false);
    }
  }

  const clearSearch = () => {
    setShowFaciltyDropdown(false);
    setSearchText('');
    setAccountNotFoundFlag(false);
  }

  const handleFacilityChange = () => {
    setShowFaciltyDropdown(false);
    setSearchText('');
  }

  const onKeyDownHandler  = (e: any) => {
    if (e.keyCode === 13) {
      handleSearch();
    }
  };

  useEffect(() => {
    if(props.reset)
    {
      clearSearch();    
    }
    
  }, [props.path])

  return (

    <div className="searchbar-wrapper">
      {showFaciltyDropdown && searchResultFacilities &&
        <Card>
            {searchResultFacilities?.map((opt: SearchAccountDTO, key: any) => (
              <Link className="search-link" key={key} onClick={handleFacilityChange} to={getRouteLink(opt)}>
                  <Tooltip tip={`${opt.name} - ${opt.coid}`}>
                    <div className="cursor-pointer d-flex align-items-center">
                      <span aria-label={opt.name} className="name">
                        {opt.name}
                      </span> - 
                      <span className="coid">{opt.coid}</span>
                    </div>
                  </Tooltip>
              </Link>
            ))}
        </Card>

      }
      
      { accountNotFoundFlag &&
        <div className="neu-chip">
          <span className="neu-text-gray-100">Account Not Found !</span>
        </div>
      }

      <div className="neu-form neu-input neu-margin--left-auto searchbar-width"
        role="search">
        <input placeholder="Search Account #"
          id="search-account-input"
          value={searchText}
          className="neu-form__native"
          type="text"
          aria-disabled="false"
          aria-label="search"
          onKeyDown={onKeyDownHandler}
          onChange={(e) => setSearchText(e.target.value)} />
          <button onClick={clearSearch} className={searchText.length > 0 ? 'neu-button--small close-btn active' : 'neu-button--small close-btn'}>
            <Icon value='close'></Icon>
          </button>
          { loader ?
            <button className="kind-primary neu-button--raised neu-button--small">
              <div className="searchbar-loader"> 
                <Loader size="small" loaderColor="blue" kind="spinner"/>
              </div> 
            </button> :
            <button id="search-account-button" onClick={handleSearch} className="kind-primary neu-button--raised neu-button--small">
              <Icon value="search"></Icon>
            </button>
          }
      </div>
    </div>

  );
}
export default AccountSearchBar;